import { render, staticRenderFns } from "./DigitalClinicsBookingPayment.vue?vue&type=template&id=55e89aee"
import script from "./DigitalClinicsBookingPayment.vue?vue&type=script&lang=js"
export * from "./DigitalClinicsBookingPayment.vue?vue&type=script&lang=js"
import style0 from "./DigitalClinicsBookingPayment.vue?vue&type=style&index=0&id=55e89aee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports